import React from 'react';
import { ModuleBase, Link } from '@/components';
import { ModuleBaseModel, ModuleBasePropsModel, LinkModel } from '@/types';
import classNames from 'classnames';

interface MacroDriverItem {
  id: string;
  categoryDisplayName: string;
  landingPageLink: LinkModel;
}

interface MacroDriverGroup {
  title: string;
  backgroundColor: string;
  items: MacroDriverItem[];
}

export type MacroDriversListingModuleModel = ModuleBaseModel<
  {
    social: MacroDriverItem[];
    technological: MacroDriverItem[];
    environmental: MacroDriverItem[];
    economic: MacroDriverItem[];
    political: MacroDriverItem[];
  } & ModuleBasePropsModel
>;

const MacroDriversListingModule: React.FC<MacroDriversListingModuleModel> = ({ props, ...moduleProps }) => {
  const macroDrivers: MacroDriverGroup[] = [
    {
      title: 'Social',
      backgroundColor: '#ffbd6e',
      items: props?.social || [],
    },
    {
      title: 'Technological',
      backgroundColor: '#446873',
      items: props?.technological || [],
    },
    {
      title: 'Environmental',
      backgroundColor: '#518b6f',
      items: props?.environmental || [],
    },
    {
      title: 'Economic',
      backgroundColor: '#d63c48',
      items: props?.economic || [],
    },
    {
      title: 'Political',
      backgroundColor: '#4a4d7f',
      items: props?.political || [],
    },
  ];

  return (
    <ModuleBase data={{ props, ...moduleProps }}>
      <div className="pl-[42px]">
        <div className="flex flex-row justify-center">
          {macroDrivers.map((macroDriverGroup, index) => (
            <div key={index} className="mx-2 mb-4 flex flex-col items-start gap-2">
              {/* Title Chip */}
              <div
                className="mb-2 flex h-8 w-full items-center justify-center rounded-full px-2 text-white uppercase"
                style={{
                  backgroundColor: macroDriverGroup.backgroundColor,
                  fontSize: '16px',
                  fontFamily: 'Sohne, sans-serif',
                }}
              >
                {macroDriverGroup.title}
              </div>

              {/* Individual Macro Driver Chips */}
              <div className="flex w-full flex-col gap-1">
                {macroDriverGroup.items.map((macroDriver) => (
                  <div
                    key={macroDriver.id}
                    className={classNames(
                      'inline-flex items-center rounded border border-gray-300 px-3 py-1 whitespace-nowrap text-black',
                      'bg-white text-xs transition-colors duration-200 hover:bg-gray-100',
                      'h-[20px] w-fit cursor-pointer justify-center p-1',
                    )}
                    style={{
                      borderRadius: '11px',
                      justifyContent: 'flex-start',
                      margin: '4px 0px',
                    }}
                  >
                    <Link
                      link={macroDriver.landingPageLink}
                      className="truncate text-center no-underline hover:text-gray-900"
                    >
                      {macroDriver.categoryDisplayName}
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </ModuleBase>
  );
};

export default MacroDriversListingModule;
